import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import PageServicesFactory from '../Services/factory.js'

class GetUrlPageUseCase extends UseCase {
  #getUrlService

  constructor({getUrlService}) {
    super()
    this.#getUrlService = getUrlService
  }

  @tracer({metric: 'GetUrlPageUseCase#execute'})
  @AsyncInlineError()
  async execute({pageName, params}) {
    try {
      const response = await this.#getUrlService.execute({
        pageName,
        params
      })

      return response
    } catch (error) {
      return Promise.reject(error)
    }
  }

  static create({config}) {
    return new GetUrlPageUseCase({
      getUrlService: PageServicesFactory.getUrlService({config})
    })
  }
}

export const factory = GetUrlPageUseCase.create
